import { render, staticRenderFns } from "./LineChart.vue?vue&type=template&id=bea359bc&scoped=true&"
import script from "./LineChart.vue?vue&type=script&lang=js&"
export * from "./LineChart.vue?vue&type=script&lang=js&"
import style0 from "./LineChart.vue?vue&type=style&index=0&id=bea359bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea359bc",
  null
  
)

export default component.exports